// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wiki.intro ol li {\n  list-style: decimal;\n}\n.wiki.intro ul li {\n  list-style: disc;\n}\n.wiki.intro li {\n  margin: 0 0 20px 40px;\n}\n.wiki.intro img {\n  display: inline;\n  vertical-align: middle;\n  height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
